module.exports = __webpack_public_path__ + "static/media/plano_villa_alemana.c9cbd10b.png";